<template>
  <div class="container">
    <hr class="space space-sm">
    <h1 v-if="purchasedSubjects">Мои предметы</h1>
    <div class="row" v-if="purchasedSubjects">
      <div class="col-md-12 mb-4" v-for="subject in purchasedSubjects" :key="subject.id">
        <subject-card :subject="subject" :isPurchased="true"></subject-card>
      </div>
    </div>
    <hr class="space space-md">

    <h2 class="h1">Доступные</h2>
    <div class="row" v-if="subjects">
      <div class="col-md-12 mb-4" v-for="subject in filteredSubjects" :key="subject.id">
        <subject-card :subject="subject"></subject-card>
      </div>
    </div>
    <hr class="space space-md">

    <!-- <h2 class="h1">В пакете дешевле</h2>
    <div class="row">
      <div class="col-md-6">
        <img class="img-fluid" src="/static/images/subjects/pack1.jpg" alt="">
      </div>
      <div class="col-md-6">
        <img class="img-fluid" src="/static/images/subjects/pack2.jpg" alt="">
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SubjectCard from './Includes/SubjectCard'

export default {
  name: 'subjects',
  components: {
    subjectCard: SubjectCard
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      subjects: state => state.students.publicSubjects
    }),
    purchasedSubjects () {
      if (this.user.subjects) {
        return this.subjects.filter((subject) => {
          return this.user.subjects.includes(subject.slug)
        })
      }
    },
    filteredSubjects () {
      if (this.user.subjects) {
        return this.subjects.filter((subject) => {
          return !this.user.subjects.includes(subject.slug)
        })
      } else {
        return this.subjects
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  created () {
    this.$store.dispatch('GET_PUBLIC_SUBJECTS')
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
